import React, { Component, PropTypes } from 'react';

import './Input.scss';

export default class Input extends Component {
  static propTypes = {
    className: PropTypes.string,
    invalid: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.any,
  };

  static defaultProps = {
    className: 'input',
    invalid: false,
    onBlur: undefined,
    onChange: undefined,
    onDragStart: undefined,
    onDrop: undefined,
    onFocus: undefined,
    placeholder: undefined,
    value: undefined,
  };

  render() {
    const { className, invalid } = this.props;
    const childProps = Object.assign({}, this.props);
    delete childProps.invalid;
    delete childProps.className;

    const invalidClassName = invalid ? `${className}--invalid` : '';

    return (<input
      className={`${className} ${invalidClassName}`}
      {...childProps}
    />);
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Input/Input.jsx
 **/